<template>
    <el-dialog title="请输入支付密码" :visible.sync="visible" width="360px" :close-on-press-escape="false" :close-on-click-modal="false">
        <i class="iconfont icon-zhifumima"></i>
        <div class="content">
            {{ content }}
        </div>
        <el-input type="password" placeholder="请输入支付密码" v-model="form.password_pay" autocomplete="off"></el-input>
        <div class="tips">
            如您忘记支付密码，请前往<a class="link" href="personal/password_pay" target="_blank"><strong>个人中心->设置支付密码</strong></a
            >，进行重置。
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="on_ok" :disabled="!form.password_pay">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                visible: false,
                callback: null,
                content: null,
                form: {
                    password_pay: null,
                },
            };
        },
        watch: {
            visible() {
                this.form.password_pay = null;
            },
        },
        created() {
            this.$event_bus.$on("password_pay", (callback, content) => {
                this.callback = callback;
                this.content = content;
                this.visible = true;
            });
        },
        methods: {
            on_ok() {
                this.callback(this.form.password_pay);
                this.visible = false;
            },
        },
    };
</script>

<style lang="less" scoped>
    .iconfont {
        font-size: 60px;
        margin-left: auto;
        margin-right: auto;
        width: 100px;
        display: block;
        text-align: center;
        margin-bottom: 24px;
        color: #FF622B;
    }
    .content {
        margin-bottom: 24px;
        color: #ff5722;
    }
    .tips {
        margin-top: 12px;
        color: #9e9e9e;
        font-size: 12px;
    }
</style>
